export const PDP_PAGE_TYPE = 'product_display';
export const BUNDLE_PAGE_TYPE = 'bundle_display';
export const DYNAMIC_PAGE_TYPE = 'dynamic_pdp';
export const PROMO_BANNER_DETAILS_MODAL_LINK = 'link_promotion_modal';
export const PROMO_BANNER_LINK_BUTTON = 'link_default';
export const PROMO_BANNER_LANDING_PAGE_TYPE = ['landing_page', 'blog'];
export const PROMO_BANNER_PRODUCT_PAGE_TYPE = [BUNDLE_PAGE_TYPE, DYNAMIC_PAGE_TYPE, PDP_PAGE_TYPE];
export const PROMO_BANNER_SYSTEM_PAGE_TYPE = ['system_page'];
export const PROMO_BANNER_DARK_COLOR = 'promo-alt';
export const convertCentAmountToDollar = (value) => value / 100; 
export const convertDifferenceToPercentage = (cartValue, tierBenchmarks) =>
  tierBenchmarks?.map((tierBenchmark, i) => {
    const previousTierBenchmark = i > 0 ? tierBenchmarks[i - 1] : 0;

    if (cartValue >= tierBenchmark) {
      return 100; 
    }
    if (cartValue <= previousTierBenchmark) {
      return 0;
    } 
    const increaseAmountWithinTier = cartValue - previousTierBenchmark;
    const tierRange = tierBenchmark - previousTierBenchmark;
    const percentageIncreaseWithinTier = (increaseAmountWithinTier / tierRange) * 100;
    return Math.min(percentageIncreaseWithinTier, 100); 
  })
  
export const convertDollarToCentAmount = (dollarAmount) => Number(dollarAmount)*100;

export const getCurrentTier = (percentages) => {
  if (percentages[3] === 100) {
    return 3;
  }
  const currentIndex = percentages.findIndex((percentage, index) => 
    percentage === 100 && (index + 1 < percentages.length) && percentages[index + 1] < 100
  );

  return currentIndex !== -1 ? currentIndex : 0;
};